<template>
  <section :style="{ 'background-color': $theme.grey }">
    <div class="row LP-header">
      <div class="col">
        <div class="container">
          <router-link
            :to="{ name: 'main-application', params: $route.params.id }"
            aria-label="Back to loan overview"
            tabindex="4"
          >
            <h1 style="font-weight: normal;cursor: pointer" class="display-4">
              <round-icon name="fa fa-users" type="info"></round-icon>
              <!-- TODO: Tie to Loan TypeID -->
              Mortgage Loan
              <small class="text-muted"
                >/ Borrower(s)
                <i
                  class="fa fa-lock text-success success"
                  aria-hidden="true"
                ></i>
              </small>
            </h1>
          </router-link>

          <div
            class="col"
            style="margin-top: -2rem;margin-left: 2.5rem;padding-right: 2.5rem;"
          >
            <base-progress
              v-if="progress != 0"
              style="padding: 0; margin-top: 20px;margin-bottom: -30px;"
              type="success"
              :value="progress"
              :showPercent="false"
            ></base-progress>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row" style="padding-top: 40px;overflow-y: scroll;padding-bottom: 160px;" v-if="app.fields">
        <div class="col">
          <template>
            <h5>
              Will you be applying for this loan by yourself or with
              co-borrower(s)?
            </h5>
            <div style="margin-top: 2rem">
              <base-radio
                name="false"
                class="mb-3"
                v-model="app.fields.borrowerStatus"
                :valid="coValid"
              >
                By myself
              </base-radio>
              <base-radio
                name="true"
                class="mb-3"
                v-model="app.fields.borrowerStatus"
                :valid="coValid"
              >
                I will have a co-borrower(s)
              </base-radio>
            </div>

            <div
              class="row"
              v-if="app.fields.borrowerStatus === 'true'"
              style="margin-top: 4rem;"
            >
              <div class="col">
                <h6>Co-Borrowers</h6>
                <p>
                  Enter your co-borrower(s) information below. We will send them
                  a invitation via the email address and phone number provided below. Note: Your
                  co-borrower(s) will not be able to see any of your personal
                  information. For security, the invitation will only be good
                  for 24 hours. After that, you will need to send a new
                  invitation.
                </p>
                <div class="loader" v-if="loading">
                  <div class="loader-box">
                    <i
                      class="fa fa-spinner success"
                      :style="{ color: $theme.success }"
                      aria-hidden="true"
                    ></i>
                  </div>
                </div>
                <div
                  v-if="
                    invitedBorrowers.invited.length ||
                      invitedBorrowers.accepted.length
                  "
                  style="margin-bottom: 2rem"
                >
                  <div v-for="(user, i) of invitedBorrowers.invited" :key="i">
                    <div
                      class="row"
                      style="background: #f4f5f7;padding: 1rem 0;border-radius: 8px;margin-bottom: .4rem;"
                    >
                      <div
                        class="col"
                        style="display: flex;align-items: center;justify-content: space-between;"
                      >
                        <div style="display: flex;align-items: center;">
                          <i
                            style="cursor: pointer; margin-right: 1rem"
                            class="fa fa-close"
                            @click="
                              deleteBorrower = true;
                              deleteUser = user;
                            "
                            v-b-tooltip.hover.top
                            title="Remove"
                          ></i>
                          <div>{{ user.FirstName }} {{ user.LastName }}</div>
                          <div
                            class="hideMobile"
                            style="font-weight: lighter;margin-left: 10px;"
                          >
                            ({{ user.Email }})
                          </div>
                          <div
                            class="status"
                            style="margin-left: 2rem; font-weight: bold"
                            :style="{
                              color:
                                user.Status == 'Invited'
                                  ? $theme.primary
                                  : $theme.warning,
                            }"
                          >
                            {{ user.Status }}
                          </div>
                        </div>

                        <div
                          v-if="user.Status == 'Expired'"
                          @click="resendInvite(user)"
                          style="margin-left: 20px;cursor: pointer;"
                          :style="{ color: $theme.primary }"
                        >
                          Resend
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-for="(user, i) of invitedBorrowers.accepted" :key="i">
                    <div
                      class="row"
                      style="background: #f4f5f7;padding: 1rem 0;border-radius: 8px;margin-bottom: .4rem;"
                    >
                      <div
                        class="col"
                        style="display: flex;align-items: center"
                      >
                        <i
                          style="cursor: pointer; margin-right: 1rem"
                          class="fa fa-close"
                          @click="
                            deleteBorrower = true;
                            deleteUser = user;
                          "
                          v-b-tooltip.hover.top
                          title="Remove"
                        ></i>
                        <div>{{ user.FirstName }} {{ user.LastName }}</div>
                        <div
                          class="hideMobile"
                          style="font-weight: lighter;margin-left: 10px;"
                        >
                          ({{ user.Email }})
                        </div>
                        <div
                          class="status"
                          style="margin-left: 2rem;font-weight: bold"
                          :style="{
                            color:
                              user.Status == 'Accepted'
                                ? $theme.success
                                : $theme.warning,
                          }"
                        >
                          {{ user.Status }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    class="coBors"
                    v-for="(borrower, i) of borrowers"
                    :key="i"
                  >
                    <div class="row">
                      <div class="col" style="text-align: right;">
                        <i
                          style="cursor: pointer"
                          class="fa fa-close"
                          @click="removeBorrower(i)"
                          v-b-tooltip.hover.top
                          title="Remove"
                        ></i>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col">
                        <label for="firstName"
                          >First Name
                          <span style="color:#fb6340">*</span></label
                        >
                        <base-input
                          addon-left-icon="fa fa-user"
                          placeholder="First Name"
                          id="firstName"
                          v-model="borrower.fName"
                          type="text"
                          :valid="borrower.fNameValid"
                          @change="borrower.fNameValid = null"
                          :required="true"
                        ></base-input>
                      </div>
                      <div class="col">
                        <label for="lastName"
                          >Last Name <span style="color:#fb6340">*</span></label
                        >
                        <base-input
                          addon-left-icon="fa fa-user"
                          placeholder="Last Name"
                          id="lastName"
                          v-model="borrower.lName"
                          type="text"
                          :valid="borrower.lNameValid"
                          @change="borrower.lNameValid = null"
                          :required="true"
                        ></base-input>
                      </div>
                      <div class="col">
                        <label for="dob"
                          >Date of Birth
                          <span style="color:#fb6340">*</span></label
                        >
                        <base-input
                          id="dob"
                          addon-left-icon="ni ni-calendar-grid-58"
                          :required="true"
                          :valid="borrower.doBirthValid"
                          @change="borrower.doBirthValid = null"
                        >
                          <flat-picker
                            slot-scope="{ focus, blur }"
                            @on-open="focus"
                            @on-close="blur, borrower.doBirthValid = null;"
                            :config="{ allowInput: true, dateFormat: 'm/d/Y' }"
                            class="form-control datepicker"
                            v-model="borrower.doBirth"
                            style="color: #172b4d;"
                          >
                          </flat-picker>
                        </base-input>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <label for="phoneNumber"
                          >Mobile Phone Number
                          <span style="color:#fb6340">*</span></label
                        >
                        <base-input
                          addon-left-icon="fa fa-phone"
                          placeholder="Mobile Phone Number"
                          id="phoneNumber"
                          v-model="borrower.pNumber"
                          type="text"
                          v-mask="'+1 (###) ###-####'"
                          :valid="borrower.pNumberValid"
                          @change="
                            borrower.pNumberValid = null;
                            borrower.pNumberError = false;
                          "
                          :required="true"
                        ></base-input>
                        <small
                          style="color: #db2d05"
                          v-if="borrower.pNumberError"
                          >{{ borrower.pNumberError }}</small
                        >
                      </div>
                      <div class="col">
                        <label for="emailAddress"
                          >Email Address
                          <span style="color:#fb6340">*</span></label
                        >
                        <base-input
                          addon-left-icon="fa fa-at"
                          placeholder="Email Address"
                          id="emailAddress"
                          :valid="borrower.eAddressValid"
                          @change="
                            borrower.eAddressValid = null;
                            borrower.eAddressError = false;
                          "
                          v-model="borrower.eAddress"
                        ></base-input>
                        <small
                          style="color: #db2d05"
                          v-if="borrower.eAddressError"
                          >{{ borrower.eAddressError }}</small
                        >
                      </div>
                    </div>
                  </div>
                  <div class="addMor" style="text-align: right;">
                    <base-button
                      type="default"
                      icon="fa fa-plus"
                      class="btn-sm"
                      @click="addAnotherBorrower"
                      >Add Co-Borrower</base-button
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div style="margin-bottom: 4rem">
                  <base-button
                    type="primary"
                    style="margin-top: 20px;"
                    @click="save"
                    >Next</base-button
                  >
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <modal :show.sync="deleteBorrower">
      <h6 slot="header" class="modal-title" id="modal-title-default">
        Remove Co-Borrower?
      </h6>
      <p>
        Are you sure you want to remove this co-borrower from your loan
        application?
      </p>
      <template slot="footer">
        <base-button type="danger" @click="removeBorrowerPerm"
          >Remove</base-button
        >
        <base-button type="link" class="ml-auto" @click="deleteBorrower = false"
          >Close
        </base-button>
      </template>
    </modal>
  </section>
</template>

<script>
import BaseRadio from "../components/BaseRadio.vue";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  saveCoBorrowers,
  getAllCoBorrowers,
  getApplication,
  deleteCoBorrowers,
  reInviteCoBorrowers,
  saveApplication,
} from "../services/application";
import BaseInput from "../components/BaseInput.vue";
import BaseButton from "../components/BaseButton.vue";
import { success, warning } from "../services/message";
import { getUserInfo } from "../services/auth";
import { validateEmail } from "../libs/validate"
export default {
  components: { BaseRadio, flatPicker, BaseInput, BaseButton },
  name: "application",
  data() {
    return {
      id: null,
      app: {},
      coBorrower: null,
      coValid: null,
      invitedBorrowers: {
        invited: [],
        accepted: [],
      },
      progress: 0,
      borrowers: [],
      deleteBorrower: false,
      deleteUser: null,
      loading: false,
      users: null,
    };
  },
  async created() {
    let res;
    if (this.$route.params.id !== "new") {
      this.id = this.$route.params.id;
      res = await getApplication(this.id);

      if (res.status === 200 && !res.coBorrower) {
        this.getBorrowers();
        if (!res.LoanAppJSON.fields) {
          res.LoanAppJSON.fields = { borrowerStatus: "false" };
        }
        this.app = res.LoanAppJSON;
        this.progress = this.app.progress.sections.coBorrower.progress;
        let data = await getUserInfo();
        this.user = data.user;
        this.user.PhoneNumber = `+${this.user.PhoneNumber[0]} (${this.user.PhoneNumber[1]}${this.user.PhoneNumber[2]}${this.user.PhoneNumber[3]}) ${this.user.PhoneNumber[4]}${this.user.PhoneNumber[5]}${this.user.PhoneNumber[6]}-${this.user.PhoneNumber[7]}${this.user.PhoneNumber[8]}${this.user.PhoneNumber[9]}${this.user.PhoneNumber[10]}`;
      } else if (res.status === 200 && res.coBorrower) {
        this.$router.push(`/application/${this.$route.params.id}/fields`);
      } else {
        this.$router.push("/");
        warning(res.message);
      }
    } else {
      this.$router.push("/");
      warning(res.message);
    }
  },
  methods: {
    async resendInvite(user) {
      let res = await reInviteCoBorrowers(user, this.id);
      if (res.status == 200) {
        this.getBorrowers();
      }
    },
    addAnotherBorrower() {
      this.borrowers.push({
        fName: "",
        fNameValid: null,
        lName: "",
        lNameValid: null,
        doBirth: "",
        doBirthValid: null,
        pNumber: "",
        pNumberValid: null,
        pNumberError: false,
        eAddress: "",
        eAddressValid: null,
        eAddressError: false,
        invited: false,
      });
    },
    removeBorrower(i) {
      this.borrowers.splice(i, 1);
    },
    async removeBorrowerPerm() {
      this.loading = true;
      await deleteCoBorrowers(this.deleteUser, this.id);
      this.deleteBorrower = false;
      this.deleteUser = null;
      this.getBorrowers();
    },
    async getBorrowers() {
      this.loading = true;
      let result = await getAllCoBorrowers(this.id);
      if (result.status === 200 && result.invited && result.accepted) {
        this.invitedBorrowers = result;

        if (
          this.invitedBorrowers.invited.length ||
          this.invitedBorrowers.accepted.length
        ) {
          this.app.borrowers = "true";
        } else {
          this.app.borrowers = "false";
        }
      } else {
        this.$router.push(`/application/${this.$route.params.id}/fields`);
      }
      this.loading = false;
    },
    async save() {
      let valid = true;
      if (this.borrowers.length) {
        for (let i = 0; i < this.borrowers.length; i++) {
          const b = this.borrowers[i];
          for (const key in b) {
            if (
              !key.includes("Valid") &&
              !key.includes("invited") &&
              !key.includes("Error") &&
              !b[key].length
            ) {
              b[key + "Valid"] = false;
              valid = false;
            }

            if (key === "pNumber") {
              if (b["pNumber"] === this.user.PhoneNumber) {
                valid = false;
                b["pNumberValid"] = false;
                b["pNumberError"] =
                  "Phone number can not be the same as primary borrowers phone number. You can not add yourself as a Co-Borrower.";
              }
            }

            if (key === "eAddress") {
              if (
                b["eAddress"].toLowerCase() === this.user.Email.toLowerCase()
              ) {
                valid = false;
                b["eAddressValid"] = false;
                b["eAddressError"] =
                  "Email can not be the same as primary borrowers email. You can not add yourself as a Co-Borrower.";
              }

              if (!validateEmail(b["eAddress"])) {
                valid = false;
                b["eAddressValid"] = false;
                b["eAddressError"] =
                  "Email entered for the Co-Borrower is not a valid email address. Pleas eenter a valid email address.";

              }
            }
          }
        }

        if (valid) {
          this.loading = true;
          this.app.progress.sections.coBorrower = { progress: 100 };
          let res = await saveCoBorrowers(
            this.borrowers,
            this.$route.params.id
          );
          await saveApplication(this.$route.params.id, this.app);
          if (res.status == 200) {
            this.loading = false;
            success("Application Saved");
            this.progress = 100;
            setTimeout(() => {
              this.$router.push({
                name: "fields",
                params: { id: this.$route.params.id },
              });
            }, 300);
          }
        }
      } else {
        this.app.fields.borrowerStatus = "false";
        this.app.progress.sections.coBorrower = { progress: 100 };
        await saveApplication(this.$route.params.id, this.app);
        success("Application Saved");
        this.$router.push({
          name: "fields",
          params: { id: this.$route.params.id },
        });
      }
    },
  },
};
</script>
<style lang="scss">
.coBors {
  border-bottom: 1px solid #525f7f;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
}

@media (max-width: 800px) {
  .hideMobile {
    display: none;
  }
}
</style>
